<form #thisForm="ngForm" (ngSubmit)="submit()">
  <app-dados-boleta
    titulo="Dados da Boleta - Ordem de Operação Estruturada"
    [operationDate]="this.model.operationDate"
    [id]="this.model.id"
    [accountManagerName]="model.accountManagerName"
    [accountManagerDocument]="model.accountManagerDocument"
    [statusDescription]="model.statusDescription"
  >
  </app-dados-boleta>

  <div *ngIf="showNewTabButton()" class="row">
    <div class="col-2">
      <label>Cód. Op. Estruturada</label>
      <span
        data-cy="operationDate"
        class="d-block p-2 bg-dark text-white text-center"
      >
        {{ mainTicketId ?? model.structuredOperationId }}
      </span>
    </div>
    <div class="col-2">
      <input
        type="button"
        style="margin-top: 19px"
        value="Abrir Ordem em Nova Aba"
        class="btn btn-primary"
        (click)="openTicketOnNewTab()"
      />
    </div>
  </div>

  <div class="card mt-3">
    <div class="card-header text-uppercase">Tipo da Liquidação</div>
    <div class="card-body">
      <div class="col-12">
        <div
          class="form-check form-check-inline"
          *ngFor="let item of ListaTipoLiquidacao; index as i"
        >
          <input
            class="form-check-input"
            type="radio"
            id="TipoLiquidacao-{{ i }}-id"
            name="settlementTypeId"
            [(ngModel)]="model.settlementTypeId"
            [value]="item.id"
            required
          />
          <label class="form-check-label" for="TipoLiquidacao-{{ i }}-id">
            {{ item.name }}
          </label>
        </div>
      </div>
    </div>
  </div>

  <app-dados-fundo
    #portfolio
    [canEdit]="false"
    [canValidate]="canValidate"
    [ticketType]="TicketTypeEnum.CETIP"
    [settlementType]="model.settlementTypeId"
    [isCetipStructured]="true"
  >
  </app-dados-fundo>

  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados da Operação</div>
    <div class="card-body">
      <div class="row mb-2" *ngIf="isFieldAvailable('operationTypeId')">
        <div class="col-4" [class.has-error]="hasError('operationTypeId')">
          <label>Tipo Operação</label>

          <div *ngIf="isTED() || isCETIP()">
            <div
              class="form-check form-check-inline"
              *ngFor="let item of TiposCompra; index as i"
            >
              <input
                class="form-check-input"
                type="radio"
                id="TipoOperacao-{{ i }}-id"
                name="operationTypeId"
                [(ngModel)]="model.operationTypeId"
                [value]="item.id"
                [required]="isTED() || isCETIP()"
              />

              <label class="form-check-label" for="TipoOperacao-{{ i }}-id">
                {{ item.name }}
              </label>
            </div>
          </div>

          <div *ngIf="isNoFinancial()">
            <div
              class="form-check form-check-inline"
              *ngFor="let item of ListaNoFinancial; index as i"
            >
              <input
                class="form-check-input"
                type="radio"
                id="TipoOperacaoNoFinancial-{{ i }}-id"
                name="operationTypeId"
                [(ngModel)]="model.operationTypeId"
                [value]="item.id"
                [required]="isNoFinancial"
              />

              <label
                class="form-check-label"
                for="TipoOperacaoNoFinancial-{{ i }}-id"
              >
                {{ item.name }}
              </label>
            </div>
          </div>
        </div>

        <div class="col-4" [class.has-error]="hasError('amount')" *ngIf="isFieldAvailable('amount')">
          <label>Quantidade</label>
          <input
            type="number"
            class="form-control"
            data-cy="amount"
            name="amount"
            [(ngModel)]="model.amount"
            required
            maxlength="17"
            (ngModelChange)="calculateOperationValue()"
          />
        </div>

        <div
          class="col-4"
          [class.has-error]="hasError('unitPrice')"
          *ngIf="!isNoFinancial() && isFieldAvailable('unitPrice')"
        >
          <label>PU (Preço Unitário)</label>
          <input
            type="text"
            class="form-control"
            data-cy="unitPrice"
            name="unitPrice"
            [(ngModel)]="model.unitPrice"
            [required]="isSell() || isPurchase()"
            maxlength="35"
            currencyMask
            (ngModelChange)="calculateOperationValue()"
          />
        </div>
      </div>

      <div class="row mb-2" *ngIf="isFieldAvailable('operationValue')">
        <div
          class="col-4"
          [class.has-error]="hasError('operationValue')"
          *ngIf="isCETIP() || isTED()"
        >
          <label>Valor da Operação</label>
          <input
            type="text"
            data-cy="operationValue"
            class="form-control"
            name="operationValue"
            [(ngModel)]="model.operationValue"
            currencyMask
            maxlength="38"
            [required]="isSell() || isPurchase()"
          />
        </div>

        <app-out-custody></app-out-custody>
      </div>
      <div class="row mb-2" *ngIf="isSell() && isFieldAvailable('operationCode')">
        <div class="col-4">
          <label>Código da Operação</label>
          <input
            data-cy="operationCode"
            type="text"
            class="form-control"
            name="operationCode"
            [(ngModel)]="model.operationCode"
            maxlength="20"
            [required]="isSell()"
          />
        </div>
      </div>

      <div class="row mb-2" *ngIf="isFieldAvailable('acquisitionDate')">
        <div class="col-4" *ngIf="isSell() || isNoFinancial()">
          <label>Data Aquisição</label>

          <input
            type="text"
            data-cy="acquisitionDate"
            class="form-control"
            name="acquisitionDate"
            maxlength="10"
            [(ngModel)]="model.acquisitionDate"
            [textMask]="{ mask: validator.dateMask, guide: false }"
          />
        </div>

        <div class="col-4" *ngIf="isNoFinancial() && isFieldAvailable('subscriptionDate')">
          <label>Data da Subscrição</label>

          <input
            type="text"
            data-cy="subscriptionDate"
            class="form-control"
            name="subscriptionDate"
            maxlength="10"
            [(ngModel)]="model.subscriptionDate"
            [textMask]="{ mask: validator.dateMask, guide: false }"
            [required]="isNoFinancial()"
          />
        </div>
      </div>

      <div class="row mb-2">
        <div *ngIf="!isEscritoTermo() && isFieldAvailable('assetType')" class="col-4">
          <label>Tipo de Ativo</label>
          <select
            [class.required-active]="
              thisForm.touched && model.assetType == null
            "
            data-cy="assetType"
            class="form-control"
            [(ngModel)]="model.assetType"
            name="assetType"
            [disabled]="!canEdit()"
            [ngModelOptions]="{ standalone: true }"
            required
          >
            <option value="-1">(nenhum)</option>
            <option
              *ngFor="let item of ListaTipoDoDoAtivo"
              name="assetType"
              [value]="item.name"
            >
              {{ item.name }}
            </option>
          </select>
        </div>

        <div class="col-4" *ngIf="isFieldAvailable('assetCode')">
          <label>Código do Ativo/ IF</label>
          <input
            type="text"
            class="form-control"
            data-cy="assetCode"
            name="assetCode"
            maxlength="20"
            [(ngModel)]="model.assetCode"
            [required]="!isTED()"
          />
        </div>

        <div class="col-4" [class.has-error]="hasError('expirationDate')" *ngIf="isFieldAvailable('expirationDate')">
          <label>Data Vencimento</label>
          <input
            type="text"
            class="form-control"
            name="expirationDate"
            data-cy="expirationDate"
            maxlength="10"
            [(ngModel)]="model.expirationDate"
            [textMask]="{ mask: validator.dateMask, guide: false }"
            [required]="isPurchase()"
          />
        </div>
      </div>
      <div class="row mb-2" *ngIf="isFieldAvailable('isCetipVoice')">
        <div class="col-4" *ngIf="isCetipVoice()">
          <label for="isCetipVoice">Cetip Voice?</label>
          <div>
            <div class="form-check form-check-inline">
              <input
                data-cy="isCetipVoice"
                [readonly]="true"
                class="form-check-input"
                id="isCetipVoiceId"
                name="isCetipVoice"
                [(ngModel)]="model.isCetipVoice"
                type="checkbox"
              />
            </div>
          </div>
        </div>
        <div class="col-4" *ngIf="isCetipVoice()">
          <label>Número Voice</label>
          <input
            type="text"
            class="form-control"
            data-cy="voiceNumber"
            name="voiceNumber"
            [(ngModel)]="model.voiceNumber"
            maxlength="20"
            [textMask]="{ mask: validator.cetipNumber, guide: false }"
          />
        </div>
      </div>

      <div class="row mb-2" *ngIf="(isTED() || isCETIP()) && isFieldAvailable('issueFee')">
        <div class="col-4">
          <label>Taxa Emissão</label>
          <input
            type="text"
            class="form-control"
            data-cy="issueFee"
            name="issueFee"
            [(ngModel)]="model.issueFee"
            maxlength="21"
            [required]="isSell() || isPurchase()"
          />
        </div>
        <div class="col-4" [class.has-error]="hasError('issueDate')" *ngIf="isFieldAvailable('issueDate')">
          <label>Data Emissão</label>
          <input
            type="text"
            class="form-control"
            data-cy="issueDate"
            name="issueDate"
            maxlength="10"
            [(ngModel)]="model.issueDate"
            [textMask]="{ mask: validator.dateMask, guide: false }"
            [required]="isSell() || isPurchase()"
          />
        </div>

        <div class="col-4">
          <label>Emissor</label>
          <input
            type="text"
            data-cy="issuer"
            class="form-control"
            name="issuer"
            [(ngModel)]="model.issuer"
            maxlength="90"
            [required]="isSell() || isPurchase()"
            *ngIf="isFieldAvailable('issuer')"
          />
        </div>
      </div>

      <div class="row mb-2" *ngIf="(isTED() || isCETIP()) && isFieldAvailable('index')">
        <div class="col-4">
          <label>Indexador</label>
          <input
            type="text"
            data-cy="index"
            class="form-control"
            name="index"
            [(ngModel)]="model.index"
            maxlength="8"
            [required]="isSell() || isPurchase()"
          />
        </div>
        <div class="col-4" *ngIf="isFieldAvailable('indexPercent')">
          <label>Percentual do Indexador</label>
          <input
            type="text"
            data-cy="indexPercent"
            class="form-control"
            name="indexPercent"
            [(ngModel)]="model.indexPercent"
            [required]="isSell() || isPurchase()"
          />
        </div>

        <div
          *ngIf="isFieldAvailable('indexTax')"
          class="col-4"
        >
          <label>Taxa Indexador</label>
          <input
            type="text"
            class="form-control"
            data-cy="indexTax"
            name="indexTax"
            maxlength="50"
            [(ngModel)]="model.indexTax"
          />
        </div>
      </div>

      <div class="row mb-2" *ngIf="(isRealty || isOtherAsset) && isFieldAvailable('faceValue')">
        <div class="col-4">
          <label>Valor da Face</label>
          <input
            type="number"
            data-cy="faceValue"
            class="form-control"
            name="faceValue"
            currencyMask
            [required]="isRealty"
          />
        </div>
        <div class="col-4" *ngIf="isFieldAvailable('updatedValue')">
          <label>Valor Atualizado</label>
          <input
            type="number"
            data-cy="updatedValue"
            class="form-control"
            name="updatedValue"
            currencyMask
            [required]="isRealty"
          />
        </div>

        <div class="col-4" *ngIf="isFieldAvailable('updatedValueDate')">
          <label>Data do Valor Atualizado</label>
          <input
            type="text"
            class="form-control"
            data-cy="updatedValueDate"
            name="updatedValueDate"
            [textMask]="{ mask: validator.dateMask, guide: false }"
            [required]="isRealty"
          />
        </div>
      </div>

      <div class="row mb-2" *ngIf="isOtherAsset && isFieldAvailable('updatedExpirationDate')">
        <div class="col-4">
          <label>Data de Vencimento Atualizada</label>
          <input
            type="text"
            data-cy="updatedExpirationDate"
            class="form-control"
            name="updatedExpirationDate"
            [textMask]="{ mask: validator.dateMask, guide: false }"
            [required]="isOtherAsset"
          />
        </div>

        <div class="col-4" *ngIf="isFieldAvailable('paymentSquare')">
          <label>Praça de Pagamento</label>
          <input
            type="number"
            class="form-control"
            data-cy="paymentSquare"
            name="paymentSquare"
            [required]="isOtherAsset"
          />
        </div>
      </div>

      <div class="row mb-2" *ngIf="(isTED() || isCETIP()) && isFieldAvailable('indexBase')">
        <div class="col-4" [class.has-error]="hasError('indexBase')">
          <label>Base Indexador</label>
          <div>
            <div
              class="form-check form-check-inline"
              *ngFor="let item of ListaBaseIndexador; index as i"
            >
              <input
                class="form-check-input"
                data-cy="indexBase"
                type="radio"
                id="indexBase-{{ i }}-id"
                name="indexBase"
                [(ngModel)]="model.indexBase"
                [value]="item.id"
              />

              <label class="form-check-label" for="indexBase-{{ i }}-id">
                {{ item.name }}
              </label>
            </div>
          </div>
        </div>

        <div class="col-4" [class.has-error]="hasError('interestType')" *ngIf="isFieldAvailable('interestType')">
          <label for="termo">Tipo de Juros do Indexador</label>
          <div>
            <div
              class="form-check form-check-inline"
              *ngFor="let item of ListaTipoJuros; index as i"
            >
              <input
                class="form-check-input"
                data-cy="interestType"
                type="radio"
                id="interestType-{{ i }}-id"
                name="interestType"
                [(ngModel)]="model.interestType"
                [value]="item.id"
                [required]="isSell() || isPurchase()"
              />

              <label class="form-check-label" for="interestType-{{ i }}-id">
                {{ item.name }}
              </label>
            </div>
          </div>
        </div>

        <div
          *ngIf="isFieldAvailable('settlementDate')"
          class="col-4"
          [class.has-error]="hasError('settlementDate')"
        >
          <label>Data Liquidação</label>
          <input
            type="text"
            class="form-control"
            name="settlementDate"
            data-cy="settlementDate"
            maxlength="10"
            [(ngModel)]="model.settlementDate"
            [textMask]="{ mask: validator.dateMask, guide: false }"
            required
          />
        </div>
      </div>
      <div
          *ngIf="isFieldAvailable('officialRequisition')"
          class="col-4"
        >
          <label>Ofício Requisitório</label>
          <input
            type="text"
            class="form-control"
            name="officialRequisition"
            data-cy="officialRequisition"
            maxlength="100"
            [(ngModel)]="model.officialRequisition"
          />
        </div>
    </div>
  </div>

  <app-counterpart
    #counterpart
    [ticketType]="TicketTypeEnum.CETIP"
    [isSecondaryMarketCetip]="model.isSecondaryMarket"
    [isTedCETIP]="isTED()"
    [isCETIP]="isCETIP()"
    [isNoFinancialCETIP]="isNoFinancial()"
    [canValidate]="canValidate"
    [canEdit]="canEdit()"
    [model]="this.model"
    [isStructuredOrder]="true"
    [isStructuredOrderNoFinancial]="isNoFinancial()"
  >
  </app-counterpart>

  <div class="card mt-3" *ngIf="isOtherAsset">
    <div class="card-header text-uppercase">Dados do Devedor</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col">
          <label
            for="
          debtorName"
            >Nome/Razão Social
          </label>
          <input
            type="text"
            class="form-control"
            data-cy="debtorName"
            name="debtorName"
            ngModel="model.debtorName"
            [required]="isOtherAsset"
          />
        </div>

        <div class="col">
          <label for="debtorDocument">CPF/CNPJ</label>
          <input
            type="number"
            class="form-control"
            data-cy="debtorDocument"
            name="debtorDocument"
            ngModel="model.debtorDocument"
            [required]="isOtherAsset"
          />
        </div>
      </div>
    </div>
  </div>

  <app-annotation #annotation [annotation]="model.annotations"></app-annotation>

  <app-attachment
    #attachment
    [ticketId]="model.id"
    [canEdit]="canEdit()"
    [canChangeStatus]="canChangeStatus()"
    [statusDescription]="model.statusDescription"
    (tempTicketId)="setTempId($event)"
    (uploadedFilesCount)="setUploadedFilesCount($event)"
  ></app-attachment>

  <div class="actions" *ngIf="canEdit()">
    <input
      type="button"
      data-cy="submit"
      value="Salvar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="submit()"
      [debounceTime]="200"
    />
    <input
      type="button"
      data-cy="forward"
      value="Encaminhar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="forward()"
      [debounceTime]="200"
    />
    <input
      type="button"
      value="Cancelar"
      class="btn btn-danger me-2"
      [disabled]="!canCancel()"
      appDebounceClick
      (debounceClick)="cancel()"
      [debounceTime]="200"
    />
  </div>

  <div class="actions" *ngIf="canChangeStatus()">
    <input
      type="button"
      value="Aprovar"
      data-cy="approve"
      class="btn btn-success me-2"
      appDebounceClick
      (debounceClick)="approve()"
      [debounceTime]="200"
    />
    <input
      type="button"
      value="Reprovar"
      data-cy="reject"
      class="btn btn-danger me-2"
      appDebounceClick
      (debounceClick)="reject()"
      [debounceTime]="200"
    />
  </div>

  <div class="actions" *ngIf="canDuplicate()">
    <input
      type="button"
      value="Duplicar"
      data-cy="duplicate"
      class="btn btn-primary me-2"
      [disabled]="!model.id"
      appDebounceClick
      (debounceClick)="duplicate()"
      [debounceTime]="200"
    />
  </div>
</form>
<app-workflow-history
  [ticketId]="model.id"
  [refresh]="dataChanged"
></app-workflow-history>
